import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'AutoGenIcon',
})
export class AutoGenIconPipe implements PipeTransform {
  static AUTO_GEN_ICON = '<=>';
  static supportedFileTypes = ['pdf', 'png', 'jpg', 'jpeg', 'gif', 'doc', 'docx', 'ad'];

  transform(value: string, overrideValue: any): string {
    if (overrideValue === AutoGenIconPipe.AUTO_GEN_ICON) {
      const getExtension = value?.split('.')?.pop()?.toLowerCase() || '';
      return AutoGenIconPipe.supportedFileTypes.includes(getExtension) ? getExtension : 'FILE';
    }
    return overrideValue;
  }
}
